import React, { ReactNode } from 'react';

import { AutocompleteRenderInputParams, SxProps, Theme } from '@mui/material';
import {
  AutocompleteArrayInput as AdminAutocompleteArrayInput,
  AutocompleteArrayInputProps as AdminAutocompleteArrayInputProps,
  FieldTitle,
  InputHelperText,
  useInput,
} from 'react-admin';
import { TextField } from 'shared/mui/TextField/TextField';
import { fieldWidth } from 'themes/layout';

export type AutocompleteArrayInputProps = {
  renderInput?: (params: AutocompleteRenderInputParams) => ReactNode;
  readOnly?: boolean;
  shrink?: boolean;
} & AdminAutocompleteArrayInputProps;

const defaultSx: SxProps<Theme> = {
  '.MuiFormControl-root': {
    margin: 0,
  },
  '.MuiFormHelperText-root': {
    marginTop: 0,
  },
  ...fieldWidth.medium,
};

export const AutocompleteArrayInput: React.FC<AutocompleteArrayInputProps> = ({
  sx,
  shrink = true,
  readOnly,
  isRequired: isRequiredOverride,
  ...props
}) => {
  const {
    fieldState: { error, invalid, isTouched },
    formState: { isSubmitted },
  } = useInput({
    source: props.source || '',
    isRequired: isRequiredOverride,
  });

  return (
    <AdminAutocompleteArrayInput
      readOnly={readOnly}
      renderInput={(params: AutocompleteRenderInputParams) => {
        const mergedTextFieldProps = {
          ...params.InputProps,
          ...props.TextFieldProps?.InputProps,
        };

        return (
          <TextField
            {...params}
            InputLabelProps={{ shrink: shrink || undefined }}
            // @ts-ignore
            InputProps={mergedTextFieldProps}
            error={(isTouched || isSubmitted) && invalid}
            helperText={<InputHelperText error={error?.message} helperText={props.helperText} />}
            label={
              <FieldTitle
                isRequired={isRequiredOverride ?? (props as any)?.validate?.isRequired}
                label={props.label}
                resource={props.resource}
                source={props.source}
              />
            }
            size={props.size}
            variant={props.variant}
          />
        );
      }}
      sx={{ ...defaultSx, ...sx }}
      {...props}
    />
  );
};
